module.exports = __webpack_public_path__ + "img/leonix-Pymes.78f8d89a.jpg";